import { CrossSectionComponent } from '@pages/cross-section/cross-section/CrossSectionComponent';
import { CrossSectionStore, ICrossSectionLoadSelection } from '@pages/cross-section/cross-section/CrossSectionStore';
import { CrossSectionViewState } from '@pages/cross-section/shared/CrossSectionWindow';

import React from 'react';

interface CrossSectionPanelProps {
    station?: number;
    lat1?: number;
    lon1?: number;
    lat2?: number;
    lon2?: number;
    view?: CrossSectionViewState;
    searchDisplacement?: number;
    deltaZFilter?: number;
    selection?: ICrossSectionLoadSelection;
    embedded?: boolean;
    onStoreReady?: (store: CrossSectionStore | null) => void;
}

export const CrossSectionPanel: React.FC<CrossSectionPanelProps> = ({ station, lat1, lon1, lat2, lon2, view, searchDisplacement, deltaZFilter, selection, embedded, onStoreReady }) => {
    return (
        <div className='flex-column' style={embedded ? { width: '100%', height: '100%' } : { minWidth: 320, minHeight: 300 }}>
            <CrossSectionComponent
                station={station}
                lat1={lat1}
                lon1={lon1}
                lat2={lat2}
                lon2={lon2}
                view={view}
                searchDisplacement={searchDisplacement}
                deltaZFilter={deltaZFilter}
                selection={selection}
                embedded={embedded}
                onStoreReady={onStoreReady}
            />
        </div>
    );
};
